import React from "react"
import {NavBar, Footer, SecondaryCTA} from "../../../components"
import {Link} from "react-router-dom"
import "./legalPage.css"


function LegalPage() {
    return (
    <div className="legal-page">
        <NavBar />
        <main className="main-container">
            <section className="header-bg">
                <div className="page-header">
                    <h1>Mentions légales</h1>
                    <p>En vigueur au 12/04/2022</p>

                    <p>Conformément aux dispositions des Articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie numérique, dite L.C.E.N., il est porté à la connaissance des utilisateurs et visiteurs, ci-après l""Utilisateur", du site www.acaciapp.com , ci-après le "Site", les présentes mentions légales.</p>
                    <p>La connexion et la navigation sur le Site par l’Utilisateur implique acceptation intégrale et sans réserve des présentes mentions légales.</p>
                    <p>Ces dernières sont accessibles sur le Site à la rubrique « Mentions légales ».</p>

                    <h3>ARTICLE 1 - L'EDITEUR</h3>
                    <p>L’édition et la direction de la publication du Site est assurée par Maxime Courtaigne, domicilié 55 rue Lacordaire, dont le numéro de téléphone est 0637952943, et l'adresse e-mail maxime.courtaigne@gmail.com</p>
                    <p>ci-après l'"Editeur".</p>

                    <h3>ARTICLE 2 - L'HEBERGEUR</h3>
                    <p>L'hébergeur du Site est la société Firebase Inc, dont le siège social est situé au 22 4th Street Suite 1000 San Francisco, CA 94103 United States , avec le numéro de téléphone : (650) 253-0000 </p>

                    <h3>ARTICLE 3 - ACCES AU SITE</h3>
                    <p>Le Site est accessible en tout endroit, 7j/7, 24h/24 sauf cas de force majeure, interruption programmée ou non et pouvant découlant d’une nécessité de maintenance.</p>
                    <p>En cas de modification, interruption ou suspension du Site, l'Editeur ne saurait être tenu responsable.</p>

                    <h3>ARTICLE 4 - COLLECTE DES DONNEES</h3>
                    <p>Le Site assure à l'Utilisateur une collecte et un traitement d'informations personnelles dans le respect de la vie privée conformément à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés. </p>
                    <p>En vertu de la loi Informatique et Libertés, en date du 6 janvier 1978, l'Utilisateur dispose d'un droit d'accès, de rectification, de suppression et d'opposition de ses données personnelles. L'Utilisateur exerce ce droit via un <Link to="/contact">formulaire de contact</Link></p>
                    <p>Toute utilisation, reproduction, diffusion, commercialisation, modification de toute ou partie du Site, sans autorisation de l’Editeur est prohibée et pourra entraînée des actions et poursuites judiciaires telles que notamment prévues par le Code de la propriété intellectuelle et le Code civil.</p>
                
                </div>
                <Link to="/" className="link-router">
                    <SecondaryCTA text="RETOUR À L'ACCUEIL"/>
                </Link>
            </section>
        </main>
        <Footer />
    </div>  
    )
}

export default LegalPage